import { type FC, type PropsWithChildren, useMemo, useRef } from 'react';

import { ElementsRefContextProvider } from '../../context/ElementsRefContext';

export const ElementsRefProvider: FC<PropsWithChildren> = ({ children }) => {
  const filtersRef = useRef<HTMLElement>(null);
  const listingRef = useRef<HTMLDivElement>(null);
  const mapContainerRef = useRef<HTMLDivElement>(null);

  const context = useMemo(() => ({ filtersRef, listingRef, mapContainerRef }), []);

  return <ElementsRefContextProvider value={context}>{children}</ElementsRefContextProvider>;
};
